export type ListingRulesEditSnapshot = {
  index: number
  group: any
} | null

const clone = <T,>(v: T): T => JSON.parse(JSON.stringify(v))

/**
 * Snapshot a rule group before editing (because v-model mutates live state).
 */
export function snapshotRuleGroup(rules: any[] | undefined, index: number): ListingRulesEditSnapshot {
  if (!Array.isArray(rules)) return null
  const group = rules[index]
  if (!group) return null
  return { index, group: clone(group) }
}

/**
 * Cancel editing.
 * - If editing a newly-added draft group, removes it.
 * - Otherwise restores the snapshot for that group index (if provided).
 *
 * Mutates `rules` in-place (matches Vue reactive array usage).
 */
export function cancelRuleGroupEdit(params: {
  rules: any[] | undefined
  editingIndex: number | null
  isNewGroupDraft: boolean
  snapshot: ListingRulesEditSnapshot
}): { editingIndex: null; isNewGroupDraft: false; snapshot: null } {
  const { rules, editingIndex, isNewGroupDraft, snapshot } = params

  if (Array.isArray(rules) && editingIndex !== null) {
    if (isNewGroupDraft) {
      rules.splice(editingIndex, 1)
    } else if (snapshot && snapshot.index === editingIndex) {
      rules[editingIndex] = clone(snapshot.group)
    }
  }

  return { editingIndex: null, isNewGroupDraft: false, snapshot: null }
}

